export const ROLE_TRANSLATIONS: Record<string, string> = {
    Admin: 'Administrador',
    Operator: 'Operario',
}

export const translateRole = (roleName: string): string => {
    return ROLE_TRANSLATIONS[roleName] || roleName
}
